import { Controller } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VannbarenVarme } from '../components/vannbarenVarme';
import { AboutFormControlProps } from '../../types';
import { validateKjel } from '../utils';

export const VannbarenVarmeVarmepumpe: FC<AboutFormControlProps> = ({ control }) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="oppvarming.oppvarmingVarmepumpe.vannbarenVarme"
      rules={{
        validate: (value) => {
          if (!validateKjel(value) && !value?.radiator && !value?.gulvvarme) {
            return t('register.errorMessage.field.vannbarenVarmeVarmepumpe');
          }

          return true;
        }
      }}
      render={({ field, fieldState }) => (
        <VannbarenVarme error={fieldState.error} value={field.value} onChange={field.onChange} />
      )}
    />
  );
};
